module.exports = __webpack_public_path__ + "static/img/SourceSansPro-BoldItalic.72aa907.svg";